import { IBreadcrumbItem, PanelType } from '@fluentui/react';
import { useBoolean } from '@fluentui/react-hooks';
import {
  IconButton,
  iconButtonStylesNoBG,
  IPageHeaderProps,
  IPanelProps,
  PageHeader,
  pageHeaderStylesSecondary,
  Panel,
  useClassNames,
} from '@h2oai/ui-kit';
import { useEffect } from 'react';

import { ContentsTitle, defaultPanelWidth } from '../../featurestore/models';
import { JobWithInfo } from '../JobList/JobList';
import { RetrieveDownload } from '../RetrieveDownload/RetrieveDownload';
import {
  IRetrieveDownloadPanelClassNames,
  IRetrieveDownloadPanelStyles,
  retrieveDownloadPanelStylesDefault,
} from './RetrieveDownloadPanel.styles';

const getBreadcrumbItems = (name?: string): IBreadcrumbItem[] => {
  return [
    { text: `${ContentsTitle.featureSet}: ${name}`, key: `${ContentsTitle.featureSet} ${name}` },
    {
      text: ContentsTitle.download,
      key: ContentsTitle.download,
      isCurrentItem: true,
    },
  ];
};

interface IRetrieveDownloadPanelProps {
  job?: JobWithInfo;
  show: boolean;
  onDismiss: (ev?: KeyboardEvent | React.SyntheticEvent<HTMLElement, Event> | undefined, updated?: boolean) => void;
}

export const RetrieveDownloadPanel = ({ job, show, onDismiss }: IRetrieveDownloadPanelProps) => {
  const [isOpen, { setTrue: open, setFalse: close }] = useBoolean(false);
  const panelProps: IPanelProps = {
    type: PanelType.custom,
    customWidth: defaultPanelWidth,
    isOpen,
    onDismiss,
    isFooterAtBottom: true,
    hasCloseButton: false,
  };

  const pageHeaderProps: IPageHeaderProps = {
    pageTitle: ContentsTitle.download,
    styles: pageHeaderStylesSecondary,
    breadcrumbProps: {
      items: getBreadcrumbItems(job?.featureSetName),
    },
    actions: <IconButton styles={iconButtonStylesNoBG} iconName="Clear" onClick={() => onDismiss()} />,
  };

  useEffect(() => {
    if (show) {
      open();
    } else {
      close();
    }
  }, [show]);
  const classNames = useClassNames<IRetrieveDownloadPanelStyles, IRetrieveDownloadPanelClassNames>(
    'RetrieveDownloadPanel',
    retrieveDownloadPanelStylesDefault
  );
  return (
    <Panel {...panelProps}>
      <div className={classNames.root}>
        <PageHeader {...pageHeaderProps} />
        <RetrieveDownload job={job} onClose={onDismiss} />
      </div>
    </Panel>
  );
};
